import {cn} from '@common-web/lib/utils';

// Fallback header mark when a site has no logo: the site name as a wordmark. Multi-word
// names get the trailing word(s) in the brand color as an accent. Uses concrete colors
// (not enroll CSS vars) so it also renders in the builder preview outside the layout.
export function SiteWordmark({
  name,
  primaryColor,
  className,
}: {
  name: string;
  primaryColor?: string;
  className?: string;
}) {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const base = cn('text-xl font-bold tracking-tight text-neutral-900 sm:text-2xl', className);

  if (words.length <= 1) {
    return <span className={base}>{name}</span>;
  }

  const [first, ...rest] = words;
  return (
    <span className={base}>
      {first} <span style={{color: primaryColor || '#1F3A5F'}}>{rest.join(' ')}</span>
    </span>
  );
}
